/**
 * Core Modules Index
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'app.core/modules';
const log = debug(MODULE_NAME);

import * as toggleClass from './toggle-class';
import "./sliders";
import * as forms from './forms';
import "./anchor-tabs/plugin--split";
import * as disableOnSubmit from './disable-on-submit';
import * as addToCart from './add-to-cart';
import * as analyticsTrigger from './analytics-trigger';
import "./commerce-analytics-impression";
import * as dismiss from './dismiss';
import * as clickTracking from './click-tracking';
import * as lazyLoad from './lazy-load';
import * as tabs from './tabs';
import * as modaal from './modaal';
import * as swiper from './swiper';
import * as showOnChange from './show-on-change';
import * as addressAutocomplete from './address-autocomplete';
import * as windcave from './windcave-iframe-container';
import * as commerceAnalyticsTrigger from './commerce-analytics-trigger';

import './sortable-products';
import './cart-summary';
import './cart-quantity';
import './update-cart';
import './button-count';
import './checkbox-set';

import './picture-fix/plugin--available';
import './filter-panel';
import './product-listing-page';
import './submits-on-changed';
import './search-filter-form';
import './cart-delivery-page';
import './cart-notification';
import './site-header';
import './alert-bar';
import './password-toggle/plugin--split';
import './form-validation/plugin--available';
import './ajax-submit/plugin--available';
import './video-block/plugin--split';
import './pop-window/plugin--split';
import './mirror-value/plugin--split';
import './cart-count/plugin--split';
import './colour-list';
import './fancy-selection';
import './forms/input-qty';
import './hover-label';
import './mini-cart/plugin--split';
import './modaal-ajax';
import './open-simple-modal/plugin--split';
import './payment-form/plugin--available';
import './scroll-to-top';
import './search';
import './simple-modal/plugin--split';
import './swatch-grid';
import './swatch-row';
import './wysiwyg';
import './hotjar';
import './zendesk';
import './paypal-payment/plugin--available';
import './afterpay-payment/plugin--available';
import './applepay-payment/plugin--available';
import './clone-dialog/index--split';
import './commerce-analytics-impression/index';
import './button-pending-state';
import './quick-order/plugin--available';
import './ga-tracking-event';

// Export
function exec () {
	log('Running...');

	forms.exec();
	disableOnSubmit.exec();
	addToCart.exec();
	dismiss.exec();
	tabs.exec();
	swiper.exec();
	showOnChange.exec();
	addressAutocomplete.exec();
	clickTracking.exec();
	lazyLoad.exec();
	modaal.exec();
	windcave.exec();

	//  keep this last - triggers events consumed by customSelect
	toggleClass.exec();
	analyticsTrigger.exec();
	commerceAnalyticsTrigger.exec();
}

export default {
	exec
};



// WEBPACK FOOTER //
// ./client/src/core/components/index.js